<template>
  <v-card class="card" color="primary">
    <v-card-title class="d-flex justify-center align-center">
      <div class="text-h5 font-weight-bold">Auditorías</div>
    </v-card-title>
    <v-card-text>
      <v-container>
        <v-row>
          <v-col align="right">
            <!-- <TextButton @click="openRegistroNuevaAuditoria">Registrar auditoría</TextButton> -->
          </v-col>
        </v-row>
        <v-row>
          <v-col cols="12">
            <v-card class="card" color="primary" :loading="loading">
              <v-card-text>
                <v-data-table :headers="headers" :items="auditoriasTable" class="transparent" :loading="loading">
                  <template v-slot:[`item.fecha`]="{ item }">
                    {{ formatFecha(item.fecha) }}
                  </template>
                </v-data-table>
              </v-card-text>
            </v-card>
          </v-col>
        </v-row>
      </v-container>
    </v-card-text>
  </v-card>
</template>

<script>
import moment from 'moment'
import { mapGetters, mapMutations } from 'vuex'
import TextButton from '../../base/TextButton.vue'
import IconButton from '../../base/IconButton.vue'
import { DIALOG_TYPES } from '../../../plugins/dialog-types.js'

export default {
  components: {
    TextButton,
    IconButton,
  },
  data() {
    return {
      headers: [
        { text: 'Información', value: 'informacion', width: '20%' },
        { text: 'Fecha', value: 'fecha', width: '15%' },
        { text: 'Personal Emisor', value: 'fk_idPersonalEmisor', width: '15%' },
        { text: 'Personal Receptor', value: 'fk_idPersonalReceptor', width: '15%' },
        { text: 'Arma', value: 'fk_idArma', width: '15%' },
      ],
      loading: false,
      DIALOG_TYPES,
    }
  },
  computed: {
    ...mapGetters('armeria', {
      auditorias: 'getAuditorias',
    }),
    auditoriasTable() {
      return Array.isArray(this.auditorias) ? this.auditorias : []
    },
  },
  methods: {
    ...mapMutations('dialog', ['SET_DIALOG']),
    openRegistroNuevaAuditoria() {
      this.SET_DIALOG(DIALOG_TYPES.REGISTRAR_NUEVA_AUDITORIA)
    },
    formatFecha(fecha) {
      return fecha ? moment(fecha).format('DD/MM/YYYY') : ''
    },
  },
  created() {
    this.$store.dispatch('armeria/fetchAuditorias')
  },
}
</script>
